import axios from 'axios'

export default {
	getAll(searchParams) {
		return axios.get(window.dtServerUrl + '/carriers', {
			params: searchParams
		})
	},

	count(searchParams) {
		return axios.get(window.dtServerUrl + '/carriers/count', {
			params: searchParams
		})
	},

	getById(id) {
		return axios.get(window.dtServerUrl + '/carriers/' + id)
	},

	create(carrier) {
		return axios.post(window.dtServerUrl + '/carriers', carrier).then((response) => {
			return response?.data
		})
	},

	update(carrier) {
		return axios.put(window.dtServerUrl + '/carriers/' + carrier.id, carrier).then((response) => {
			return response?.data
		})
	},

	delete(id) {
		return axios.delete(window.dtServerUrl + '/carriers/' + id)
	}
}
